import { Shield, CheckCircle, AlertTriangle, Info } from "lucide-react";

interface AlertSourceBadgeProps {
  sourceType: string;
  className?: string;
}

export default function AlertSourceBadge({ sourceType, className = "" }: AlertSourceBadgeProps) {
  const getSourceInfo = (source: string) => {
    // Real government sources
    if (source.includes('fews_net') || source.includes('reliefweb') || source.includes('world_bank') || 
        source.includes('ministry_agriculture_ls') || source.includes('lesotho_met') || source.includes('undp') ||
        source.includes('fao_lesotho')) {
      return {
        type: 'verified',
        label: 'VERIFIED',
        icon: CheckCircle,
        bgColor: 'bg-green-100',
        textColor: 'text-green-700',
        borderColor: 'border-green-200'
      };
    }
    
    // Sample government-style data
    if (source.includes('ministry_of_agriculture') || source.includes('government_program') || 
        source.includes('veterinary_services')) {
      return {
        type: 'sample',
        label: 'SAMPLE',
        icon: AlertTriangle,
        bgColor: 'bg-yellow-100',
        textColor: 'text-yellow-700',
        borderColor: 'border-yellow-200'
      };
    }
    
    // System generated
    if (source.includes('agrosense') || source.includes('weather_service')) {
      return {
        type: 'system',
        label: 'SYSTEM',
        icon: Info,
        bgColor: 'bg-blue-100',
        textColor: 'text-blue-700',
        borderColor: 'border-blue-200'
      };
    }
    
    // Default fallback
    return {
      type: 'unknown',
      label: 'DATA',
      icon: Shield,
      bgColor: 'bg-gray-100',
      textColor: 'text-gray-700',
      borderColor: 'border-gray-200'
    };
  };

  const sourceInfo = getSourceInfo(sourceType);
  const Icon = sourceInfo.icon;

  return (
    <div className={`inline-flex items-center space-x-1 px-2 py-1 rounded-full text-xs font-medium border ${sourceInfo.bgColor} ${sourceInfo.textColor} ${sourceInfo.borderColor} ${className}`}>
      <Icon className="w-3 h-3" />
      <span>{sourceInfo.label}</span>
    </div>
  );
}